import { render } from "./kitchen.vue?vue&type=template&id=5dcd090c&scoped=true"
import script from "./kitchen.vue?vue&type=script&lang=js"
export * from "./kitchen.vue?vue&type=script&lang=js"

import "./kitchen.vue?vue&type=style&index=0&id=5dcd090c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcd090c"]])

export default __exports__